import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('authToken'));
  const [isLoading, setIsLoading] = useState(true);

  const login = async (username, password) => {
    try {
      const res = await fetch("/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (res.ok) {
        const data = await res.json();
        const authToken = data.token;
        
        // Store token in localStorage and state
        localStorage.setItem('authToken', authToken);
        setToken(authToken);
        setAuthenticated(true);
        setCurrentUser({ username: data.username });
        return true;
      } else {
        setAuthenticated(false);
        setCurrentUser(null);
        setToken(null);
        localStorage.removeItem('authToken');
        return false;
      }
    } catch (err) {
      console.error("Login failed", err);
      setAuthenticated(false);
      setCurrentUser(null);
      setToken(null);
      localStorage.removeItem('authToken');
      return false;
    }
  };

  const validateToken = async (authToken) => {
    if (!authToken) return false;

    try {
      const res = await fetch("/api/admin/validate-token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: authToken }),
      });

      if (res.ok) {
        const data = await res.json();
        setAuthenticated(true);
        setCurrentUser({ username: data.username });
        return true;
      } else {
        // Token is invalid or expired
        localStorage.removeItem('authToken');
        setToken(null);
        setAuthenticated(false);
        setCurrentUser(null);

        // If we get a 401, redirect to login (token expired)
        if (res.status === 401) {
          window.location.href = '/login';
        }

        return false;
      }
    } catch (err) {
      console.error("Token validation failed", err);
      localStorage.removeItem('authToken');
      setToken(null);
      setAuthenticated(false);
      setCurrentUser(null);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    setToken(null);
    setAuthenticated(false);
    setCurrentUser(null);
  };

  // Validate token on app initialization
  useEffect(() => {
    const initAuth = async () => {
      if (token) {
        await validateToken(token);
      }
      setIsLoading(false);
    };

    initAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ 
      authenticated, 
      currentUser, 
      token,
      isLoading,
      login, 
      logout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Admin/AuthContext.js